import { Tag, Typography } from 'antd';
import { ColumnsType } from 'antd/es/table';

import { RequestInnerResponseInterface, RequestSubInterface } from '@interface/logs/logs.interface';

export const consumerSubLogsColumns: ColumnsType<RequestSubInterface> = [
  {
    title: 'URL',
    dataIndex: 'request',
    key: 'request',
    width: '50%',
    render: (data) => <Typography.Paragraph>{data.url}</Typography.Paragraph>,
  },
  {
    title: 'Method',
    dataIndex: 'request',
    key: 'request',
    render: (data) => data?.method.toUpperCase(),
  },
  {
    title: 'Status',
    dataIndex: 'response',
    key: 'response',
    render: (data) => {
      let color = 'green';

      if (data.status >= 400) color = 'volcano';

      return <Tag color={color}>{data.status}</Tag>;
    },
  },
  {
    title: 'Latency',
    dataIndex: 'response',
    key: 'response',
    render: (data: RequestInnerResponseInterface) => `${data?.latencyMs.toFixed(2) ?? 0}ms`,
  },
];
